'use client'

import React, { useEffect, useRef } from 'react'
import { vehicleTypeConfig } from '@components/MainWidget/common/commonWidgetConfig'
import { pageEvent, waitForAnalyticsLoad } from '@acko-tech/building-blocks.ui.acko-analytics'
import { SEGMENT } from '@components/MainWidget/common/widgetSegments'
import { fetchWidgetProductFn, widgetJourney } from '@configs/segmentEvents.config'
import { FlipCard, GovernmentVerifiedBatch, NumberPlate } from '../Common/CommonComponents'
import styles from './MobileChallanModal.module.scss'

interface MobileChallanModaProps {
  regNum: string
  title: string
  subtitle: string
  description: string
  ctaHelper: string
  badgeText: string
  onSubmit: () => void
  buttonCta: string
  cardData: Array<{ image: string; text: string }>
  segmentEventCommonProperties: any
  widgetType: string
  vehicleInfoData: any
  variation: 'A' | 'B'
}

const MobileChallanModal = ({
  regNum,
  title,
  subtitle,
  description,
  ctaHelper,
  buttonCta,
  cardData,
  badgeText,
  onSubmit,
  segmentEventCommonProperties,
  widgetType,
  vehicleInfoData,
  variation,
}: MobileChallanModaProps) => {
  const hasFiredRef = useRef(false)
  useEffect(() => {
    if (!hasFiredRef.current) {
      void waitForAnalyticsLoad().then(() => {
        void pageEvent(SEGMENT.VIEW_PAGE, {
          ...segmentEventCommonProperties,
          product: fetchWidgetProductFn?.[widgetType]?.(),
          phone: vehicleInfoData?.mobile_number || '',
          registration_number: vehicleInfoData?.reg_number || '',
          vehicle_type: vehicleTypeConfig?.[vehicleInfoData?.vehicleInfo?.vehicle_type_v2] || 'N/A',
          mm_name: vehicleInfoData?.vehicleInfo?.model_name || '',
          previous_policy_expiry_date: vehicleInfoData?.vehicleInfo?.previous_policy_expiry_detail || '',
          expiry_date: vehicleInfoData?.vehicleInfo?.previous_policy_expiry_detail || '',
          vas_amount: null,
          journey: widgetJourney?.[widgetType],
          page_type: `${widgetJourney?.[widgetType]}_check_variation_${variation}`,
        })
        hasFiredRef.current = true
      })
    }
  }, [])
  return (
    <div className={styles.mobileChallanModal}>
      <div className={styles.modalContent}>
        <NumberPlate regNum={regNum} />
        <p className={styles.modalTitle}>{title}</p>
        <p className={styles.modalSubTitle}>{subtitle}</p>
      </div>
      <div className={styles.modalCard}>
        <div className={styles.card}>
          <FlipCard lightBackground data={cardData} />
          <GovernmentVerifiedBatch badgeText={badgeText} />
          <p className={styles.modalDescription}>
            {description?.split(/(<.*?>)/g)?.map((part, i) =>
              part.startsWith('<') && part.endsWith('>') ? (
                <span className={styles.bold} key={i}>
                  {part.slice(1, -1)}
                </span>
              ) : (
                <React.Fragment key={i}>{part}</React.Fragment>
              )
            )}
          </p>
        </div>
      </div>
      <div className={styles.modalBottom}>
        <button type="button" className={styles.button} onClick={onSubmit}>
          {buttonCta}
        </button>
        <p className={styles.descUnderButton}>{ctaHelper}</p>
      </div>
    </div>
  )
}

export default MobileChallanModal
